import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { requestCanceller } from '../../../../service/axiosCancelToken';
import { getUserComments } from '../../../../service/commentService';
import { getUserById } from '../../../../service/userService';
import priceFormat from '../../../../utils/showPriceFormat';
import LoadingSpinner from '../../../shared/LoadingSpinner';
import Commnets from '../../comment/UserComments';
import './UserInfo.css';

const UserInfo = () => {
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [user, setUser] = useState();
    const {addToast} = useToasts();
    const history = useHistory();
    const [lastCommentId, setLastCommentId] = useState(''); 
    const [comments, setComments] = useState(); 
    const [commentsLoading, setCommentsLoading] = useState(false);

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchUser = async () => {
            try {
                setIsLoading(true);
                let { status, data } = await getUserById(state.userId, {cancelToken: cancelRequest.signal});
                if(status === 201){
                    setUser(data.user)
                }
                setIsLoading(false);
            } catch (err) {
                if(err.response && err.response.status === 404){
                    addToast("چنین کاربری  وجود ندارد !", {
                        appearance: 'error',
                        autoDismiss: true,
                    })
                    history.replace('/dashboard/questions')
                }
            }
        } 
        fetchUser();
        return () => {
			cancelRequest.cancel();
        }
    },[history, state, addToast])

    const getUserCommentsHandler = async (userId) => {
        try {
            setCommentsLoading(true);
            const params = {
                userId: userId,
                lastCommentId: lastCommentId,
                commentsStatus: ''
            }
            const { status, data } = await getUserComments(params);
            if (status === 201) {
                if(data.comments.length){
                    const oldComments = (comments && comments.length) ? [...comments] : [];
                    const newComments = oldComments.concat(data.comments)
                    setComments(newComments)
                    setLastCommentId(newComments[newComments.length - 1]._id);
                }
                setCommentsLoading(false);
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
        }
    }


    return ( 
        <React.Fragment>
        {
            isLoading || ! user ? 
            <div style={{ height: '70vh' }} className="d-flex">
                <div className="text-center align-self-center mx-auto">
                    <LoadingSpinner />
                </div>
            </div>
            :
            <div className="user-information-layer">
                <header>
                    <h1>اطلاعات کاربری</h1>
                </header>
                <section className="mb-3">
                    <div className="my-1">
                        <span className="font-weight-bold">نام و نام خانوادگی</span>
                        <span className="mx-1">:</span>
                        <span>{user.fullName}</span>
                    </div>
                    <div className="my-1">
                        <span className="font-weight-bold">شماره موبایل</span>
                        <span className="mx-1">:</span>
                        <span>{user.mobileNumber}</span>
                    </div>
                    <div className="my-1">
                        <span className="font-weight-bold">سن</span>
                        <span className="mx-1">:</span>
                        <span>{user.age}</span>
                    </div>
                    <div className="my-1">
                        <span className="font-weight-bold">شماره ثابت</span>
                        <span className="mx-1">:</span>
                        <span>{user.telephone}</span>
                    </div>
                    <div className="my-1">
                        <span className="font-weight-bold">آدرس</span>
                        <span className="mx-1">:</span>
                        <span>{user.address}</span>
                    </div>
                    <div className="my-1">
                        <span className="font-weight-bold">کیف پول</span>
                        <span className="mx-1">:</span>
                        <span className="font-weight-bold">{priceFormat(user.wallet)} تومان</span>
                    </div>
                    <div className="my-1">
                        <span className="font-weight-bold">سفارشات</span>
                        <span className="mx-1">:</span>
                        <span className="badge badge-primary badge-pill">{user.ordersCount}</span>
                    </div>
                    <div className="my-1">
                        <span className="font-weight-bold">نظرات ثبت شده</span>
                        <span className="mx-1">:</span>
                        <span className="badge badge-warning badge-pill">{user.requestsCommentCount}</span>
                    </div>
                    <div className="my-1">
                        <span className="font-weight-bold">وضعیت</span>
                        <span className="mx-1">:</span>
                        <span className={user.status === 'Enable' ? 'text-success' : 'text-danger'}>
                            {user.status === 'Enable' ? 'فعال' : 'مسدود'}
                        </span>
                    </div>
                </section>
                <div className="my-4 col-12 item-comments-layer">
                    {
                        comments &&
                        <h5><span>نظرات</span></h5>
                    }
                    {
                        (comments && comments.length)  &&
                        <Commnets comments={comments}/> 
                    }
                    {
                        (comments && !comments.length)  &&
                        <div className="d-flex justify-content-center" style={{minHeight: '100px'}}>
                            <h6 className="align-self-center font-weight-bold">هیچ نظری تا کنون ثبت نشده است</h6>
                        </div>
                    }
                    <button className="btn btn-success mr-1 mr-md-0  mb-md-1 "
                        onClick={() => getUserCommentsHandler(user._id)}
                        disabled={commentsLoading}
                    >
                        <i 
                            className={commentsLoading ? 'spinner-border spinner-border-sm mr-2': ''} 
                            style={{position:'relative', bottom:'2px'}}
                        ></i>
                        {(comments && comments.length) ? 'مشاهده بیشتر' : 'مشاهده نظرات'} 
                    </button>
                </div>
            </div>
        }
        </React.Fragment>
    );
}
 
export default UserInfo;